import { React, useState, useEffect } from "react";

const PopUpBCasinoResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };


    let bollywoodCard = "";
    let bollywoodMarkets = [];
    let bollywoodWinners = [];

    if (marketType == 19) {

        bollywoodCard = resultData?.c1 || "";

        bollywoodMarkets = [
            "Don",
            "Amar Akbar Anthony",
            "Sahib Bibi Aur Gulam",
            "Dharam Veer",
            "Kis Kisko Pyaar Karoon",
            "Ghulam",
            "K-Q",
            "J-A",
            "Red",
            "Black",
            "J",
            "Q",
            "K",
            "A",
        ];

        bollywoodWinners = resultData?.resultTxt
            ? resultData.resultTxt
                .split(",")
                .map(item => item.trim())
            : [];
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="bollywood" style={{ display: marketType == 19 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item" style={{ textAlign: "center" }}>
                                        <b>
                                            <span className="name" style={{ color: "#000", fontSize: "17px" }} >
                                                Community Card
                                            </span>
                                        </b>
                                        <div
                                            className="player-card"
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}
                                        >
                                            <div
                                                className="BFBCardHandViewDealerab"
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    className="BFBCardFanViewab"
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        padding: "2px",
                                                        width: "100%"
                                                    }}
                                                >
                                                    {bollywoodCard && (
                                                        <div
                                                            className="RSMImageView2ab"
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center"
                                                            }}
                                                        >
                                                            <img
                                                                src={`/assets/images/cards/${bollywoodCard}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "55px",
                                                                    height: "auto"
                                                                }}
                                                                alt=""
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        {bollywoodMarkets.map((market, index) => {
                                            const winner = bollywoodWinners.includes(market);
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "22px",
                                                            fontWeight: "700",
                                                        }}
                                                    >
                                                        {market}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase",
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <style>
                {`

.RSMImageView2ab {
    padding: 0px; 
    display: contents;
}
                    

                `}
            </style>
        </div>
    );
};

export default PopUpBCasinoResults;

